import {
    keyIssueApplyFilterCriteria,
    keyIssueClearFilterCriteria,
    keyIssueSetFilter
} from "../../../actions/key-issue-actions"

import buildFilterWidgetContainer from "../../common/build-filter-widget-container"

import KeyIssueListFilterFormContainer from "./KeyIssueFilterFormContainer"

export default buildFilterWidgetContainer(
    KeyIssueListFilterFormContainer,
    keyIssueClearFilterCriteria,
    keyIssueApplyFilterCriteria,
    keyIssueSetFilter
)
